/** EFEM lock duration (seconds) — set from /api/public/bootstrap. */
export let efemLockTimeoutSeconds = 900;

export function setEfemLockTimeoutSeconds(seconds: number): void {
  efemLockTimeoutSeconds = seconds;
}
